import { Typography, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { PropsWithChildren } from 'react';
import React from 'react';

const Root = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  textTransform: 'uppercase',
  fontSize: theme.typography.fontSize,
  color: theme.palette.default.main,
  fontWeight: 'bold',
}));

interface Props {
  header?: string;
}

export const SiteLinkGroup: React.FC<PropsWithChildren<Props>> = ({ children, header }) => {
  const { getTestId } = useTestId();

  return (
    <Root>
      {header ? (
        <StyledTypography
          data-testid={getTestId('header')}
          variant="body2"
        >
          {header}
        </StyledTypography>
      ) : null}
      {children}
    </Root>
  );
};
